import { render } from "./chatAppSideBarComponent.vue?vue&type=template&id=83d0eb62&scoped=true"
import script from "./chatAppSideBarComponent.vue?vue&type=script&lang=js"
export * from "./chatAppSideBarComponent.vue?vue&type=script&lang=js"

import "./chatAppSideBarComponent.vue?vue&type=style&index=0&id=83d0eb62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d0eb62"]])

export default __exports__